import {
  LOCAL_STORAGE_DATA,
  LocalStorageController,
} from "./LocalStorageController";

export default function weAreOnPiBrowser() {
  if (
    window.location.hostname === "localhost" ||
    window.location.hostname.includes("athtest")
  ) {
    return false;
  }
  return true;
}
//window.navigator.userAgent.includes("PiBrowser");
